import type { Field } from 'factorial-form'

import createEffect from 'modules/core/hooks/createEffect'
import type { ApplicationError } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type { ValidationErrorData } from 'modules/core/lib/parseErrorData'
import { parseErrorData } from 'modules/core/lib/parseErrorData'

interface Response {
  data: ValidationErrorData
}

const useAppendErrors = createEffect(
  (error: boolean, fileField: Field, value: void | ApplicationError | null) => {
    const genericError = i18n.t('employees.import_generic_error')

    if (error) {
      const errors = (value as Response)?.data?.errors || [genericError]
      const message = parseErrorData(errors)

      fileField.setErrors([message])
    }
  }
)

export default useAppendErrors
